
import { defineComponent, onBeforeMount, reactive } from 'vue'

// components
import PageTitle from '@/common/components/UI/PageTitle/index.vue'
import FailedFetch from '@/common/components/UI/FailedFetch/index.vue'
import TableScrollWrapper from '@/common/components/UI/TableScrollWrapper/index.vue'
import TheTable from '@/common/components/UI/TheTable/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// module components
import BlogTableActions from '@/modules/BlogModule/components/BlogTableActions/index.vue'

// realisations
import { blog } from '@/core/realisations/blog.realisation'

// types
import { ArticleT } from '@/core/types/blog.types'

// classes
import { DataState } from '@/core/classes/DataState.class'

// constants
import { ArticlesColumns } from '@/core/constants/columns/Articles.columns'

export default defineComponent({
    components: {
        PageTitle,
        FailedFetch,
        TableScrollWrapper,
        TheTable,
        TheButton,
        BlogTableActions,
    },
    setup() {
        const state = reactive(new DataState<ArticleT>({}))

        const loadArticles = async (page: number) => {
            state.pagination.current_page = page

            try {
                state.is_loading = true

                const response = await blog.getArticles({ page })

                state.list = response.data
                state.pagination.total_pages = response.meta.last_page

                state.is_failed = false
                state.failure.error_state.is_cancel = false
            } catch (error) {
                state.failure.catchError(error)

                if (!state.failure.error_state.is_cancel) {
                    state.is_failed = true
                }
            } finally {
                if (!state.failure.error_state.is_cancel) {
                    state.is_loading = false
                }
            }
        }

        const formatDate = (dateStr: string) => {
            if (!dateStr) return '-'

            const dateFirst = dateStr.split(' ')[0]
            return dateFirst.split('-').reverse().join('.')
        }

        onBeforeMount(() => {
            loadArticles(1)
        })

        return {
            state,
            ArticlesColumns,
            loadArticles,
            formatDate,
        }
    },
})
